import {AbstractEvent} from "@/modules/base/events";
import {Season} from "@/modules/season/entity";

export class AfterDayEvaluationEvent extends AbstractEvent {
  constructor(
    public season: Season
  ) {
    super();
  }
}